import { loadObjectFromServer, getData } from "@/utils";
export async function getChartData(params) {
  let queryString = Object.keys(params)
    .map(function(key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  let apiUrl = `${APP_ROUTES.DASHBOARD_REVENUE}?${queryString}`;
  const response = await getData(apiUrl);
  return response;
}

export async function getBenchmarkCohortData(params) {
  let queryString = Object.keys(params)
    .map(function(key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  let apiUrl = `/benchmark/cohort/?${queryString}`;
  // console.log(apiUrl);
  const response = await getData(apiUrl);
  return response;
}

export async function getBenchmarkCohortDataRetentionMatrix(params) {
  let queryString = Object.keys(params)
    .map(function(key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  let apiUrl = `/benchmark/cohortv2/?${queryString}`;
  // console.log(apiUrl);
  const response = await getData(apiUrl);
  return response;
}

export async function getBenchmarkCohortDataCohortSize(params) {
  let queryString = Object.keys(params)
    .map(function(key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  let apiUrl = `/benchmark/cohortv2/?${queryString}`;
  // console.log(apiUrl);
  const response = await getData(apiUrl);
  return response;
}

export async function getBenchmarkCohort(params) {
  let queryString = Object.keys(params)
    .map(function(key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  let apiUrl = `/bigdata/cohort/?${queryString}`;
  // console.log(apiUrl);
  const response = await getData(apiUrl);
  return response;
}

export async function getSegmentDashboardData(params) {
  let queryString = Object.keys(params)
    .map(function(key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  let apiUrl = `/benchmark/segment-dashboard/?${queryString}`;
  const response = await getData(apiUrl);
  return response;
}

export async function getTotalSales(params, get_prev_sales) {
  if (get_prev_sales) params.is_prev_sales = true;
  let queryString = Object.keys(params)
    .map(function(key) {
      return `${key}=${params[key]}`;
    })
    .join("&");
  let apiUrl = `/pos/sales/?${queryString}`;
  try {
    const response = await getData(apiUrl);
    return response;
  } catch (e) {
    return null;
  }
}
